/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Errors_Invalid_JsonInputs */



/**
* | output |
* | --- |
* | "Invalid JSON" |
*
* @param {Errors_Invalid_JsonInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const errors_invalid_json = /** @type {((inputs?: Errors_Invalid_JsonInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Errors_Invalid_JsonInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ungültiges JSON")
	return /** @type {LocalizedString} */ ("Invalid JSON")
});